import React from 'react'
import { Outlet } from 'react-router-dom'

function MainSchedulesTesting() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainSchedulesTesting

